import browse from './browse.vue';
import read from './read.vue';

export default { browse, read };
